export interface ProductOptionToCollect {
  optionValueID: string;
  optionValueName: string;
}

export const productOptionToCollectFromResponse = (
  responseData: any,
): ProductOptionToCollect => ({
  optionValueID: responseData.option_value_id,
  optionValueName: responseData.option_value_name,
});
